import React from 'react';

import { Box, Divider, Grid, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
    ReactHookFormCheck,
    ReactHookFormIntlNumberInput,
} from 'common/components/form';

import { handleOnBlurField } from '../../helpers';

const AmountLimit = ({ control, disabled, setValue }) => {
    const { t } = useTranslation();
    const name = 'amount_values';

    const amountValues = useWatch({ control, name });

    return (
        <Box>
            <Typography fontWeight={600} variant="body2">
                {t('Amount limit')}
            </Typography>

            <Divider sx={{ mb: 2 }} />

            <Grid container>
                <Grid size="auto">
                    <ReactHookFormCheck
                        control={control}
                        disabled={disabled}
                        name={`${name}.isChecked`}
                    />
                </Grid>
                <Grid size="grow">
                    <ReactHookFormIntlNumberInput
                        append="MXN"
                        control={control}
                        disabled={
                            !amountValues || !amountValues.isChecked || disabled
                        }
                        fullWidth
                        label={t('Minimum amount')}
                        name={`${name}.min`}
                        prepend="$"
                        onBlur={({ value }) =>
                            handleOnBlurField({
                                name: `${name}.min`,
                                setValue,
                                value,
                            })
                        }
                    />
                </Grid>

                <Grid size="grow">
                    <ReactHookFormIntlNumberInput
                        append="MXN"
                        control={control}
                        disabled={
                            !amountValues || !amountValues.isChecked || disabled
                        }
                        fullWidth
                        label={t('Maximum amount')}
                        name={`${name}.max`}
                        prepend="$"
                        onBlur={({ value }) =>
                            handleOnBlurField({
                                name: `${name}.max`,
                                setValue,
                                value,
                            })
                        }
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

AmountLimit.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default AmountLimit;
